import type { SimilarUnitOutreach } from "../api/crm";
import { buildSimilarUnitContext } from "../utils/similarUnitOutreach";

/** Dashed note above a part 2 message explaining why the AI agent wrote. */
export const SimilarUnitContextLine = ({
  outreach,
  contactFirstName
}: {
  outreach?: SimilarUnitOutreach;
  contactFirstName: string;
}) => {
  if (!outreach) return null;
  const context = buildSimilarUnitContext(outreach, contactFirstName);
  return (
    <div className="mb-4 flex justify-center">
      <p
        data-testid="similar-unit-context"
        className="flex max-w-[640px] w-full items-start gap-2.5 rounded-xl border border-dashed border-primary-200 bg-content-1000-inverted px-3.5 py-2.5 text-[13px] leading-5 text-content-700"
      >
        <span
          aria-hidden="true"
          className="grid size-[22px] shrink-0 place-items-center rounded-full bg-primary-20 font-bold text-primary-500"
        >
          ↻
        </span>
        <span>
          <span className="font-bold text-content-1000">
            A similar unit notification
          </span>{" "}
          matched {context.firstName} to{" "}
          <span className="font-bold text-content-1000">
            {context.unitLabel}
          </span>
          {context.unitDetails ? ` (${context.unitDetails})` : ""}.{" "}
          {context.likeSentence}
          {context.quietSentence ? ` ${context.quietSentence}` : ""}
        </span>
      </p>
    </div>
  );
};
